// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__4AEPW","row1":"Footer_row1__xaF5V","col1":"Footer_col1__XPun7","col2":"Footer_col2__6dFo4","col3":"Footer_col3__EieVh","row2":"Footer_row2__XhRud"};